<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="订单编号">
              <a-input placeholder="请输入订单编号" v-model="queryParam.orderCode"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="订单类型">
              <j-dict-select-tag placeholder="请选择订单类型" v-model="queryParam.orderType" dictCode="s_order_type"/>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="渠道订单编号">
              <a-input placeholder="请输入渠道订单编号" v-model="queryParam.channelOrderCode"></a-input>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
<!--            <a-col :xl="6" :lg="7" :md="8" :sm="24">-->
<!--              <a-form-item label="是否配送">-->
<!--                <j-dict-select-tag placeholder="请选择是否配送" v-model="queryParam.isDelivery" dictCode="yesorno"/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="客户姓名">
                <a-input placeholder="请输入客户姓名" v-model="queryParam.consumerName"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="客户手机">
                <a-input placeholder="请输入客户手机" v-model="queryParam.consumerPhone"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="支付方式名称">
                <a-input placeholder="支付方式名称" v-model="queryParam.orderPayModeName"></a-input>
              </a-form-item>
            </a-col>
<!--            <a-col :xl="6" :lg="7" :md="8" :sm="24">-->
<!--              <a-form-item label="下单时间">-->
<!--                <j-date :show-time="true" date-format="YYYY-MM-DD HH:mm:ss" placeholder="请选择下单时间" v-model="queryParam.orderCreatetime"></j-date>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="付款时间">
<!--                <j-date :show-time="true" date-format="YYYY-MM-DD HH:mm:ss" placeholder="请选择付款时间" v-model="queryParam.orderPaytime"></j-date>-->
                <j-date placeholder="请选择开始" class="query-group-cust" v-model="queryParam.orderPaytime_begin"></j-date>
                <span class="query-group-split-cust"></span>
                <j-date placeholder="请选择结束" class="query-group-cust" v-model="queryParam.orderPaytime_end"></j-date>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="取餐时间">
<!--                <j-date :show-time="true" date-format="YYYY-MM-DD HH:mm:ss" placeholder="请选择取餐时间" v-model="queryParam.orderTakeTime"></j-date>-->
                <j-date placeholder="请选择开始" class="query-group-cust" v-model="queryParam.orderTakeTime_begin"></j-date>
                <span class="query-group-split-cust"></span>
                <j-date placeholder="请选择结束" class="query-group-cust" v-model="queryParam.orderTakeTime_end"></j-date>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="订单所属门店">
                <j-dict-select-tag placeholder="请选择订单所属门店" v-model="queryParam.storeId" dictCode="sales_physical_store,phystore_name,id"/>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="订单状态">
                <j-dict-select-tag placeholder="请选择订单状态" v-model="queryParam.orderState" dictCode="s_order_state"/>
              </a-form-item>
            </a-col>
<!--            <a-col :xl="6" :lg="7" :md="8" :sm="24">-->
<!--              <a-form-item label="订单渠道">-->
<!--                <j-dict-select-tag placeholder="请选择订单渠道" v-model="queryParam.orderChanner" dictCode="sales_channel,channel_name,id"/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button type="primary" icon="download" @click="handleExportXls('订单')">导出</a-button>
      <a-button @click="myHandleDeliver" type="danger" icon="plus">发货</a-button>
      <!--<a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">-->
        <!--<a-button type="primary" icon="import">导入</a-button>-->
      <!--</a-upload>-->
      <!--<a-dropdown v-if="selectedRowKeys.length > 0">-->
        <!--<a-menu slot="overlay">-->
          <!--<a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>-->
        <!--</a-menu>-->
        <!--<a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>-->
      <!--</a-dropdown>-->
    </div>

    <!-- table区域-begin -->
    <div>
<!--      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">-->
<!--        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项-->
<!--        <a style="margin-left: 24px" @click="onClearSelected">清空</a>-->
<!--      </div>-->

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="uploadFile(text)">
            下载
          </a-button>
        </template>

        <a slot="FormNoLink" @click="myHandleDetail(record)" slot-scope="text, record" @title="text">查看详情</a>

        <span slot="orderState" slot-scope="text, record">
          <a-tag :color="setStateColor(record.orderState)">
            {{ text }}
          </a-tag>
        </span>

        <div slot="orderPayMount" slot-scope="text, record">
          <span>￥ </span>
          <span style="font-weight: 400;color:red;font-size:16pt">{{ text }}</span>
        </div>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)" :disabled="record.orderState != 'have_paid'">接单</a>
          <a-divider type="vertical" />
          <a @click="handleEdit(record)" :disabled="record.orderState == 'created'">打票</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定取消订单吗?" @confirm="() => handleDelete(record.id)">
                  <a>取消订单</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定取消吗?" @confirm="() => handleDelete(record.id)">
                  <a>取消确认</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <salesOrder-modal ref="modalForm2" @ok="modalFormOk"></salesOrder-modal>
    <sales-order-detail-modal ref="modalForm" @ok="modalFormOk"></sales-order-detail-modal>

  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import SalesOrderModal from './modules/SalesOrderModal'
  import JDictSelectTag from '@/components/dict/JDictSelectTag.vue'
  import JDate from '@/components/jeecg/JDate.vue'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import SalesOrderDetailModal from "@/views/erp/sales/modules/SalesOrderDetailModal";

  export default {
    name: "SalesOrderList",
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      SalesOrderDetailModal,
      JDictSelectTag,
      JDate,
      SalesOrderModal,
    },
    data () {
      return {
        description: '订单管理页面',
        // 表头
        columns: [
          // {
          //   title: '#',
          //   dataIndex: '',
          //   key:'rowIndex',
          //   width:60,
          //   align:"center",
          //   customRender:function (t,r,index) {
          //     return parseInt(index)+1;
          //   }
          // },
          {
            title:'订单编号',
            align:"center",
            dataIndex: 'orderCode',
            ellipsis: true,
            scopedSlots: { customRender: 'FormNoLink' },
          },
          {
            title:'渠道订单编号',
            align:"center",
            ellipsis: true,
            dataIndex: 'channelOrderCode'
          },
          {
            title:'订单状态',
            align:"center",
            dataIndex: 'orderState_dictText',
            scopedSlots: { customRender: 'orderState' },
          },
          {
            title:'订单类型',
            align:"center",
            dataIndex: 'orderType_dictText',
          },
          {
            title:'支付方式名称',
            align:"center",
            dataIndex: 'orderPayModeName',
          },
          {
            title:'订单所属门店',
            align:"center",
            ellipsis: true,
            dataIndex: 'storeId_dictText',
          },
          // {
          //   title:'订单来源',
          //   align:"center",
          //   dataIndex: 'orderSource'
          // },
          {
            title:'下单时间',
            align:"center",
            dataIndex: 'orderCreatetime'
          },
          // {
          //   title:'付款时间',
          //   align:"center",
          //   width: 180,
          //   dataIndex: 'orderPaytime'
          // },
          {
            title:'取餐时间',
            align:"center",
            width: 180,
            dataIndex: 'orderTakeTime'
          },
          {
            title:'订单实付金额',
            align:"center",
            dataIndex: 'orderTotalprice',
            scopedSlots: { customRender: 'orderPayMount' },
          },
          {
            title:'商户实收金额',
            align:"center",
            dataIndex: 'orderBusinessAmount',
            scopedSlots: { customRender: 'orderPayMount' },
          },
          // {
          //   title:'支付方式',
          //   align:"center",
          //   dataIndex: 'paymentType',
          // },
          // {
          //   title:'是否配送',
          //   align:"center",
          //   width: 80,
          //   dataIndex: 'isDelivery_dictText'
          // },
          // {
          //   title:'收货地址',
          //   align:"center",
          //   width: 180,
          //   ellipsis: true,
          //   dataIndex: 'deliveryAddress'
          // },
          // {
          //   title:'客户姓名',
          //   align:"center",
          //   width: 120,
          //   dataIndex: 'consumerName'
          // },
          // {
          //   title:'客户手机',
          //   align:"center",
          //   width: 150,
          //   dataIndex: 'consumerPhone'
          // },
          // {
          //   title:'订单原价',
          //   align:"center",
          //   dataIndex: 'orderOriginalprice'
          // },
          // {
          //   title:'订单用户价格',
          //   align:"center",
          //   dataIndex: 'orderUserprice'
          // },
          // {
          //   title:'订单配送费用',
          //   align:"center",
          //   dataIndex: 'orderDeliveryprice'
          // },
          // {
          //   title:'是否打折',
          //   align:"center",
          //   dataIndex: 'isOnsale'
          // },
          // {
          //   title:'折扣',
          //   align:"center",
          //   dataIndex: 'salePrice'
          // },
          // {
          //   title:'折扣说明',
          //   align:"center",
          //   dataIndex: 'saleContext'
          // },
          // {
          //   title:'是否使用优惠券',
          //   align:"center",
          //   dataIndex: 'isCoupon'
          // },
          // {
          //   title:'优惠券抵扣',
          //   align:"center",
          //   dataIndex: 'couponPrice'
          // },
          // {
          //   title:'优惠券名称',
          //   align:"center",
          //   dataIndex: 'couponName'
          // },
          // {
          //   title:'门店联系方式',
          //   align:"center",
          //   dataIndex: 'orderStorecontact'
          // },
          // {
          //   title:'门店负责人',
          //   align:"center",
          //   dataIndex: 'orderStoreowner'
          // },
          // {
          //   title:'购买商品列表',
          //   align:"center",
          //   dataIndex: 'relPublishids'
          // },
          // {
          //   title: '操作',
          //   dataIndex: 'action',
          //   align:"center",
          //   fixed:"right",
          //   width:147,
          //   scopedSlots: { customRender: 'action' }
          // }
        ],
        url: {
          list: "/sales/salesOrder/list",
          delete: "/sales/salesOrder/delete",
          deleteBatch: "/sales/salesOrder/deleteBatch",
          exportXlsUrl: "/sales/salesOrder/exportXls",
          importExcelUrl: "sales/salesOrder/importExcel",
        },
        dictOptions:{},
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      },
      myHandleDeliver:function (){
        this.modalFormOk()
        this.$refs.modalForm2.action = 'edit'
        this.$refs.modalForm2.edit()
      },
      myHandleDetail:function (record){
        this.modalFormOk()
        this.$refs.modalForm.action = 'detail'
        this.$refs.modalForm.detail(record)
      },
      setStateColor(state){
        switch (state) {
          case "created":
            return 'green'
          case "have_paid":
            return 'blue'
          case "accepted":
            return 'green'
          case "completed":
            return '#FF8D1A'
          case "canceling":
            return 'red'
          case "canceled":
            return 'red'
          default:
            return 'green'
        }
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>